export function getHomeUrl() {
  return `/`;
}